import React, { useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import { Link, useNavigate } from "react-router-dom";
import "./ForgetPass.css";
import logo from "../images/logo.png";
import { useAlert } from "react-alert";

const ForgetPass = () => {
  const alert = useAlert();
  const navigate = useNavigate();

  useEffect(() => {
    alert.info("Please contact Rockpros Team for password reset assistance.", {
      onClose: () => {
        navigate("/");
      }
    });
  }, [alert, navigate]);

  return (
    <div className="main_body">
      <Navbar style={{ backgroundColor: "black" }}>
        <Navbar.Brand>
          <Link to="/">
            <img
              src={logo}
              style={{ height: "7vh", width: "200px" }}
              className="d-inline-block align-top"
              alt="rockprosusa"
            />
          </Link>
        </Navbar.Brand>
      </Navbar>
      <div className="container w-25 pt-5">
        <div style={{ 
          textAlign: 'center', 
          padding: '40px 20px',
          backgroundColor: '#ffffff',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: '#f3f4f6',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px'
          }}>
            <i className="fas fa-envelope" style={{ fontSize: '32px', color: '#991C1C' }}></i>
          </div>
          <h2 style={{ 
            fontSize: '24px',
            fontWeight: 600,
            color: '#1e293b',
            marginBottom: '12px'
          }}>
            Password Reset
          </h2>
          <p style={{ 
            fontSize: '16px',
            color: '#64748b',
            lineHeight: '1.6',
            marginBottom: '24px'
          }}>
            Please contact Rockpros Team for password reset assistance.
          </p>
          <Link 
            to="/" 
            style={{
              display: 'inline-block',
              padding: '12px 24px',
              backgroundColor: '#991C1C',
              color: '#ffffff',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: 600,
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#7d1616';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#991C1C';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgetPass;
